import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Modal from "../../components/parent/Modal"
import API_ENDPOINTS from "../../utils/apiEndpoints";

const BasicInfo = () => {
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const fileInputPhotoRef = useRef(null);
    const fileInputDocumentsRef = useRef(null);

    const [classes, setClasses] = useState([]);
    const [casteCategory, setCasteCategory] = useState([]);
    const [mediums, setmediums] = useState([]);
    const [languages, setlanguages] = useState([]);
    const [genders, setgenders] = useState([]);
    const [extra_curricular_activities, setextra_curricular_activities] = useState([]);
    const [countries, setcountries] = useState([]);
    const [co_curricular_activities, setco_curricular_activities] = useState([]);
    const [blood_groups, setblood_groups] = useState([]);
    const [boards, setboards] = useState([]);



    // console.log(casteCategory);
    const [checkboxes, setCheckboxes] = useState({
        termsChecked: false,
        privacyChecked: false
    });
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        gender_id: '',
        dob: '',
        birthPlace: '',
        nationality: '',
        religion: '',
        caste_category_id: '',
        caste: '',
        motherTongue: '',
        studentEmail: '',
        blood_group_id: '',
    });



    useEffect(() => {
        const dataToSave = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            stats: formData.candidateSATSNo,
            classId: classes.find(cls => cls.id === Number(formData.classId))?.name || 'Class not found',
        };
        localStorage.setItem('formData', JSON.stringify(dataToSave));
    }, [formData.firstName, formData.lastName, formData.fatherName, formData.candidateSATSNo, classes.find(cls => cls.id === Number(formData.classId))?.name || 'Class not found']);

    const updatedPreviewData = {
        "First Name": formData.firstName,
        "Last Name": formData.lastName,
        "Gender": genders.find(cls => cls.id === Number(formData.gender_id))?.gender,
        "Date of Birth": formData.dob,
        "Place of Birth": formData.birthPlace,
        "Nationality": formData.nationality,
        "Religion": formData.religion,
        "Caste Category": casteCategory.find(cls => cls.id === Number(formData.caste_category_id))?.caste_category,
        "Caste": formData.caste,
        "Mother Tongue": formData.motherTongue,
        "Student Email": formData.studentEmail,
        "Blood Group": blood_groups.find(cls => cls.id === Number(formData.blood_group_id))?.blood_group,


    };



    useEffect(() => {
        const token = localStorage.getItem("parentToken");

        if (!token) {
            console.error("No token found in localStorage");
            return;
        }

        fetch(API_ENDPOINTS.DROPDOWN_DATA, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                setClasses(data.data.classes);
                setCasteCategory(data.data.caste_categories);
                setmediums(data.data.mediums)
                setlanguages(data.data.languages)
                setgenders(data.data.genders)
                setextra_curricular_activities(data.data.extra_curricular_activities)
                setcountries(data.data.countries)
                setco_curricular_activities(data.data.co_curricular_activities)
                setblood_groups(data.data.blood_groups)
                setboards(data.data.boards)
            })
            .catch(error => console.error("Error fetching classes:", error));
    }, []);


    const handleChange = (e) => {
        // Strip out non-English/non-ASCII characters to prevent PDF failure
        const value = e.target.value.replace(/[^\x00-\x7F]/g, '');
        setFormData({ ...formData, [e.target.name]: value });
    };

    const handleCoCurricularChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            coCurricularWishToJoin: e.target.value, // Only one selection allowed
        }));
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        setShowModal(true); // Open modal to preview data
    };


    // const handleFinalSubmit = async () => {
    //     try {
    //         const formDataObj = new FormData1();
    //         Object.keys(formData).forEach((key) => formDataObj.append(key, formData[key]));

    //         const response = await axios.post("http://127.0.0.1:8000/api/admission", formDataObj, {
    //             headers: { Authorization: `Bearer ${localStorage.getItem("parentToken")}` },
    //         });

    //         alert(response.data.message); // Show success message
    //         navigate("/parent-info");
    //         setShowModal(false); // Close modal
    //     } catch (error) {
    //         console.error("Error submitting form:", error);
    //     }
    // };


    const handleFinalSubmit = async () => {
        const token = localStorage.getItem("parentToken");
        if (!token) {
            console.error("Authentication token is missing.");
            return;
        }

        setLoading(true); // Show "Saving..."

        const requestData = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            gender_id: Number(formData.gender_id),
            dob: formData.dob,
            birth_place: formData.birthPlace,
            nationality: formData.nationality,
            religion: formData.religion,
            caste_category_id: Number(formData.caste_category_id),
            caste: formData.caste,
            mother_tongue: formData.motherTongue,
            student_email: formData.studentEmail,
            blood_group_id: Number(formData.blood_group_id),
        };

        try {
            const response = await fetch(API_ENDPOINTS.BASIC_INFO, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                let errorMessage = result.message || "An error occurred.";
                if (result.data) {
                    errorMessage += "\n" + Object.values(result.data).flat().join("\n");
                }
                alert(errorMessage);
            } else {
                // console.log("Success:", result);
                navigate(`/address-info/${result.data.basicInfo.id}`);
                setShowModal(false); // Close modal on success
                setFormData({
                    firstName: '',
                    lastName: '',
                    gender_id: '',
                    dob: '',
                    birthPlace: '',
                    nationality: '',
                    religion: '',
                    caste_category_id: '',
                    caste: '',
                    motherTongue: '',
                    studentEmail: '',
                    blood_group_id: '',
                });
            }
        } catch (error) {
            console.error("Network Error:", error);
            alert("Network error. Please try again.");
        } finally {
            setLoading(false); // Stop loading
        }
    };








    return (
        <>
            {/* Preview Modal */}
            <Modal loading={loading} show={showModal} onClose={() => setShowModal(false)} formData={updatedPreviewData} onFinalSubmit={handleFinalSubmit} />


            <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 px-4">
                <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-xl font-semibold text-center mb-4">Basic Information</h2>
                    <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">

                        {/* First Name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">First Name</label>
                            <input
                                type="text"
                                name="firstName"
                                placeholder="Enter First Name"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Last Name */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Last Name</label>
                            <input
                                type="text"
                                name="lastName"
                                placeholder="Enter Last Name"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* gender */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Select Gender</label>
                            <select
                                name="gender_id"
                                required
                                value={formData.gender_id}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500">
                                <option value="">Select Gender</option>
                                {genders.map(cls => (
                                    <option key={cls.id} value={cls.id}>{cls.gender}</option>
                                ))}
                            </select>
                        </div>

                        {/* Date of Birth */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Date of Birth</label>
                            <input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* place of birth */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Place of Birth</label>
                            <input
                                type="text"
                                name="birthPlace"
                                placeholder="Enter Place of Birth"
                                value={formData.birthPlace}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Nationality */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Nationality</label>
                            <input
                                type="text"
                                name="nationality"
                                placeholder="Enter Nationality"
                                value={formData.nationality}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Religion */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Religion</label>
                            <input
                                type="text"
                                name="religion"
                                placeholder="Enter Religion"
                                value={formData.religion}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* caste category */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Caste Category</label>
                            <select
                                name="caste_category_id"
                                required
                                value={formData.caste_category_id}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            ><option value="">Select Caste Category</option>
                                {casteCategory.map(cls => (
                                    <option key={cls.id} value={cls.id}>{cls.caste_category}</option>
                                ))}

                            </select>
                        </div>


                        {/* caste */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Caste</label>
                            <input
                                type="text"
                                name="caste"
                                placeholder="Enter Caste"
                                value={formData.caste}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* mother tongue */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Mother Tongue</label>
                            <input
                                type="text"
                                name="motherTongue"
                                placeholder="Enter Mother Tongue"
                                value={formData.motherTongue}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>



                        {/* student email */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Student Email Id</label>
                            <input
                                type="email"
                                name="studentEmail"
                                placeholder="Enter Student Email Id"
                                value={formData.studentEmail}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>


                        {/* Bloog group */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Blood Group</label>
                            <select
                                name="blood_group_id"
                                value={formData.blood_group_id}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <option value="">Select Blood Group</option>
                                {blood_groups.map(cls => (
                                    <option key={cls.id} value={cls.id}>{cls.blood_group}</option>
                                ))}

                            </select>
                        </div>




                        {/* Submit Button (Full Width) */}
                        <div className="sm:col-span-2">
                            <button
                                type="submit"
                                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                            >
                                Preview
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default BasicInfo;
